import styled from '@emotion/styled';
import React, { PropsWithChildren } from 'react';
import { TextElement } from '../../../foundations';
import { ComponentWithSizeMode } from '../../../foundations/modes/size';
import { Truncate } from '../../../utils/Truncate/Truncate';

export interface InputLabelProps extends ComponentWithSizeMode {
  htmlFor?: string;
}

export const InputLabel: React.FC<PropsWithChildren<InputLabelProps>> = ({ children, htmlFor, size }) => {
  if (!children) {
    return null;
  }

  return (
    <StyledLabel htmlFor={htmlFor}>
      <Truncate wordBreak="break-all">
        <TextElement textStyle="label" weight="bold" size={size}>
          {children}
        </TextElement>
      </Truncate>
    </StyledLabel>
  );
};

const StyledLabel = styled.label`
  display: flex;
  align-items: center;
  flex: 1;
`;
